// removed by extract-text-webpack-plugin
module.exports = {"wrapper":"SettingsLanguageForm__wrapper__1CqLV","submitResult":"SettingsLanguageForm__submitResult__20SRQ","actionWrapper":"SettingsLanguageForm__actionWrapper__2_Ynw","wrapper2faOptions":"SettingsLanguageForm__wrapper2faOptions__lxafx"};


//////////////////
// WEBPACK FOOTER
// ./src/containers/SettingsLanguages/SettingsLanguageForm.css
// module id = 3193
// module chunks = 0